import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Asset, Box, Card, Typography, useAsset } from '@altermaind/web/ui';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';

export const CardPlayground: FC = () => {
  const t = useTranslations('aiPlayground.learning.landingPlayground.aiPlayground');
  const { genericResponsiveValue } = useResponsiveStyle();

  const backGroundImage = useAsset('images', 'bgPlaygroundCard');

  return (
    <Box mt='xxl'>
      <Card
        backgroundImage={`url(${backGroundImage})`}
        backgroundSize={genericResponsiveValue({
          breakPoints: { desktop: 'cover' },
          defaultValue: 'cover',
        })}
        backgroundPosition={genericResponsiveValue({
          breakPoints: { desktop: 'center' },
          defaultValue: 'top',
        })}
        display='flex'
        flexDirection={genericResponsiveValue({
          breakPoints: { desktop: 'row' },
          defaultValue: 'column',
        })}
        backgroundColor='primary/interactive'
        alignItems='center'
        textAlign='center'
      >
        <Box flex='1' alignItems='center'>
          <Asset domain='images' name='logoAltermaind' width='m' />
          <Typography mt='xxs' variant='h3'>
            {t('title')}
          </Typography>
          <Typography mt='s' variant='h2'>
            {t('subTitle')}
          </Typography>
          <Typography mt='xs' variant='p2/light'>
            {t('description')}
          </Typography>
        </Box>
      </Card>
    </Box>
  );
};
